module.exports = __webpack_public_path__ + "img/744.755276c9.jpg";